<template>
  <div class="">
    <b-container class="px-0">
      <div class="bg-gray-light breadcrumb-wrapper">
          <b-breadcrumb 
            v-if="path" 
            :items="path"
            class="bg-gray-light mb-0">
          </b-breadcrumb>
      </div>
    </b-container>
    <b-container class="main-container bg-white py-5">
      <div class="title-wrapper dark">
            <span>
              <h1 class="font-bad font-weight-bold"> 
                {{ title }}
              </h1>
            </span>
            <i :class="topicIcon"></i>
      </div>
      <b-row>
        <div class=" main-wrapper col-12 col-lg-8">
          
        
          <main>
            <slot name="main-content"></slot>
          </main>
        </div>
        <aside class="col-12 col-lg-4">
          <slot name="related-content"></slot>
        </aside>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      Type: String,
      required: true
    },
    topicIcon: {
      Type: String,
      required: false,
      default: 'fab fa-vuejs topic-icon'
    },
    path: {
      Type: Array,
      required: false,
    }
  },
  data() {
    return {
      
    }
  },
 
}

</script>

<style scoped> @import url("https://github.githubassets.com/assets/gist-embed-4ac6018bcc05457cde2f66d2e7299d11.css"); </style>
<style>
.main-nav{
  padding: 0;
}
.main-nav .container{
  padding-top: .5rem;
  padding-bottom: .5rem;
  background: #fff;
  /*box-shadow: 0 7px 14px 0 rgba(0,0,0,.16);*/
}
</style>
<style scoped>
.title-wrapper{
  margin-bottom: 2rem;
}
.topic-icon{
  font-size: 40px;
  margin-top: 12px;
}
.fa-vuejs{
  color: #41b883;
}
.breadcrumb-item > a{
  color: inherit;
}
.breadcrumb-item.active > span{
  color: inherit;
}
</style>